"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.meQuery = void 0;
const client_1 = require("@apollo/client");
const meUser_1 = require("../fragments/meUser");
exports.meQuery = client_1.gql `
  query Me {
    me {
      __typename
      user {
        ...meUser
      }
    }
  }

  ${meUser_1.meUserFragment}
`;
//# sourceMappingURL=me.js.map